import React from 'react';
import styled from 'styled-components';

function formatISO(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getToday(): { start: string; end: string } {
  const today = new Date();
  const iso = formatISO(today);
  return { start: iso, end: iso };
}

function getThisWeek(): { start: string; end: string } {
  const today = new Date();
  const dayOfWeek = today.getDay();
  const sunday = new Date(today);
  sunday.setDate(today.getDate() - dayOfWeek);
  return { start: formatISO(sunday), end: formatISO(today) };
}

function getThisMonth(): { start: string; end: string } {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  return { start: formatISO(firstDay), end: formatISO(today) };
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

const Label = styled.span`
  font-size: ${(props) => props.theme.fontSize.small};
  color: ${(props) => props.theme.colors.lightGray};
  margin-right: 0.25rem;
`;

const QuickButton = styled.button`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.mainColor};
  color: ${(props) => props.theme.colors.mainColor};
  border-radius: ${(props) => props.theme.border.default};
  padding: 0.25rem 0.75rem;
  font-size: ${(props) => props.theme.fontSize.small};
  font-weight: 600;
  cursor: pointer;
  transition: all ${(props) => props.theme.transitionDuration.default};

  &:hover {
    background-color: ${(props) => props.theme.colors.mainColor};
    color: ${(props) => props.theme.colors.white};
  }
`;

interface Props {
  // eslint-disable-next-line no-unused-vars
  onPick: (start: string, end: string) => void;
}

function DateQuickButtons({ onPick }: Props) {
  return (
    <Container>
      <Label>Atalhos:</Label>
      <QuickButton
        type="button"
        onClick={() => {
          const { start, end } = getToday();
          onPick(start, end);
        }}>
        Hoje
      </QuickButton>
      <QuickButton
        type="button"
        onClick={() => {
          const { start, end } = getThisWeek();
          onPick(start, end);
        }}>
        Esta semana
      </QuickButton>
      <QuickButton
        type="button"
        onClick={() => {
          const { start, end } = getThisMonth();
          onPick(start, end);
        }}>
        Mês atual
      </QuickButton>
    </Container>
  );
}

export default DateQuickButtons;
